import React, { PureComponent } from 'react';
class Feedback extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            defaultTxt : this.props.uiTexts.text_21,
            allowYn : 'N',
        }
        this.handleClickClose = this.handleClickClose.bind(this)
        this.handleClickTextarea = this.handleClickTextarea.bind(this)
        this.handleChangeInput = this.handleChangeInput.bind(this)
        this.handelClickSend = this.handelClickSend.bind(this)
    }

    componentDidMount() {
		//if (this.props.data.event.eventYn !== undefined) {
			//this.setState({eventYn : this.props.data.event.eventYn})

			if (this.props.data.event.eventYn === 'Y') this.tabClick('event')
		//}
    }

    handleClickClose() {
      this.props.close()
    }

    handleClickTextarea(e) {

        if (e.type === 'click') {
            e.target.placeholder = ''
        }
        if (e.type === 'blur') {
            if (e.target.value.trim() === '') {
                e.target.value = ''
                e.target.placeholder = this.state.defaultTxt
            }
        }
    }

	getFeedbackType() {
		let ret = 'feedback'
		if (this.eventTab.className === 'on') {
			ret = 'event'
			if (this.props.data.event.eventDoiYn === 'Y') {
				ret = 'event_doi'
			} 
			
		}
		return ret;
	}
	
    handleClickViewAgree() {
		let select = this.getFeedbackType()
		let checkbox = this.cbFeedback;
		if (select === 'event') checkbox = this.cbEvent;
		if (select === 'event_doi') checkbox = this.cbEventDoi;

        if (checkbox.checked === false) {
            checkbox.checked = true;
            this.setState({allowYn : 'Y'})
			this.props.setAgreeContent(select);
            this.props.view()
        } else {
            checkbox.checked = false;
            this.setState({allowYn : 'N'})
        }
    }

    handleChangeInput(e) {
        if (e.target.checked === true) {
            this.setState({allowYn : 'Y'})
			this.props.setAgreeContent(this.getFeedbackType());
            this.props.view()
        } else {
            this.setState({allowYn : 'N'})
        }
    }

    handelClickSend () {
		let select = this.getFeedbackType();
		let textarea = this.textFeedback;
		let checkbox = this.cbFeedback;
		if (select === 'event' || select === 'event_doi') {
			textarea = this.textEvent;
			checkbox = this.cbEvent;
		} 


        if (textarea.value.trim() === '') {
            this.props.alert('의견을 입력해 주십시요')
			return
        } 
		if (select === 'event' && checkbox.checked === false) {
			this.props.alert('이벤트 참여를 위해서는 개인정보동의가 필요합니다.')
			return
		}
		if (select === 'event_doi' && (checkbox.checked === false || this.cbEventDoi.checked === false)) {
			if (checkbox.checked === false ) {
				this.props.alert('이벤트 참여를 위해서는 개인정보동의가 필요합니다.')
				return
			}

			if (this.cbEventDoi.checked === false ) {
				this.props.alert('이벤트 참여를 위해서는 제3자 개인정보 제공동의가 필요합니다.')
				return
			}
		}

		if (select === 'feedback') {
			const writeJSON = {
				"projectId" : this.props.config.projectId,
				"allowYn" : this.state.allowYn,
				"feedbackContent" : textarea.value,
				"isDev" : this.props.config.isDev
			}

			this.props.writeFeedback(writeJSON)
		}

		if (select === 'event') {
			const writeJSON = {
				"projectId" : this.props.config.projectId,
				"eventId" : this.props.data.event.eventId,
				"allowYn" : this.state.allowYn,
				"participateContent" : textarea.value,
				"isDev" : this.props.config.isDev
			}

			this.props.writeEvent(writeJSON)
		}
    }

	tabClick(tabName) {
		//console.info(this.props)
		if (tabName === 'event' && this.props.data.event.eventYn === 'N') {
			this.props.alert('현재 진행중인 이벤트가 없습니다.')
			return;
		}

		let onTab = this.feedbackTab
		let onContent = this.feedbackLayer
		let offTab = this.eventTab
		let offContent = this.eventLayer
	
		if (tabName === "event") {
			onTab = this.eventTab
			onContent = this.eventLayer
			offTab = this.feedbackTab
			offContent = this.feedbackLayer
		}
	
		onTab.className = 'on'
		onContent.style.display = 'block'
		offTab.className = ''
		offContent.style.display = 'none'

		//if (this.inputElement.checked === true) this.inputElement.checked = false;
	}

	

    render() {

        return (
            <div className="layer_wrap layer_wrap_type2 advisor_layer_wrap">
            <div className="layer_inner">
            <div className="layer_cont">
                <h2 className="layer_h_tit"/>
				<div className="tab_menu">
					<a href="#none" onClick={() => this.tabClick('feedback')} className="on" ref={feedbackTab => {this.feedbackTab = feedbackTab}}><p>의견제안</p></a>
					<a href="#none" onClick={() => this.tabClick('event')} ref={eventTab => {this.eventTab = eventTab}}><p>이벤트 참여</p></a>
                </div>
				<div className="tab_cont" ref={feedbackLayer => {this.feedbackLayer = feedbackLayer}} style={{display:'block'}}>
					<strong className="layer_sub_tit" dangerouslySetInnerHTML={{__html:this.props.uiTexts.text_18}}/>
					<label htmlFor="opinionTxt" className="lbl_txt">{this.props.uiTexts.text_19}</label>
					<div className="inp_textarea_box">
						<textarea id="opinionTxt" className="inp_textarea" placeholder={this.state.defaultTxt} onClick={this.handleClickTextarea} onBlur={this.handleClickTextarea} ref={(textFeedback)=>{this.textFeedback = textFeedback}}/>
					</div>
					<p className="layer_txt">{this.props.uiTexts.text_20}</p>
					<p className="layer_txt">
						<input type="checkbox" onChange={this.handleChangeInput} ref={(cbFeedback)=>{this.cbFeedback = cbFeedback}}/> 
						<a href="#none" onClick={() => this.handleClickViewAgree()}> <strong>(선택) 의견제안을 위한 개인정보 수집 및 이용 동의</strong></a>
					</p>
				</div>
				{ this.props.data.event !== undefined && this.props.data.event.eventYn === 'Y' &&
					<div className="tab_cont" ref={eventLayer => {this.eventLayer = eventLayer}} style={{display:'none'}}>
						<strong className="layer_sub_tit" dangerouslySetInnerHTML={{__html:this.props.data.event.eventName}}/>
						<div className="layer_txt" dangerouslySetInnerHTML={{__html:this.props.data.event.eventContent}}/>
						<div className="layer_txt">이벤트 기간 : {this.props.data.event.startTime} ~ {this.props.data.event.endTime} </div>
						<div className="inp_textarea_box">
							<textarea id="opinionTxt" className="inp_textarea" placeholder="내용을 입력해주세요.(글자수 1000자 제한)" onClick={this.handleClickTextarea} onBlur={this.handleClickTextarea} ref={(textEvent)=>{this.textEvent = textEvent}}/>
						</div>
						<p className="layer_txt">{this.props.uiTexts.text_20}</p>
						<p className="layer_txt">
							<input type="checkbox" onChange={this.handleChangeInput} ref={(cbEvent)=>{this.cbEvent = cbEvent}}/> 
							<a href="#none" onClick={() => this.handleClickViewAgree()}> <strong>(필수) 이벤트참여를 위한 개인정보 수집 및 이용 동의</strong></a>
						</p>
						{ this.props.data.event.eventDoiYn === 'Y' &&
						<p className="layer_txt">
						<input type="checkbox" onChange={this.handleChangeInput} ref={(cbEventDoi)=>{this.cbEventDoi = cbEventDoi}}/> 
							<a href="#none" onClick={() => this.handleClickViewAgree()}> <strong>(필수) 이벤트참여를 위한 제3자 개인정보 제공 동의</strong></a>
						</p>
						}
					</div>
				}


                <div className="btn_area">
                    <button type="button" className="layer_btn" onClick={this.handelClickSend}>{this.props.uiTexts.text_33}</button>
                </div>
            </div>
            <button type="button" className="btn_close" onClick={this.handleClickClose}><span className="ico_comm ico_close">레이어 닫기</span></button>
            </div>
        </div>
        );
    }
};

export default Feedback;